import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Personal Id' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tienda Id' }),
        ...DefaultColumns()
    }
)

const procs = () =>
(
    {
        dav2_getUbicacionPersonal: { name: 'dav2_getUbicacionPersonal' },
        dav2_qryIndicadores: { name: 'dav2_qryIndicadores' },
        dav2_qryMapa: { name: 'dav2_qryMapa' },
        dav2_qryDetallePersonal: { name: 'dav2_qryDetallePersonal' },
        dav2_qryDetalleTienda: { name: 'dav2_qryDetalleTienda' },
        dav2_qryMarcacionesFueraArea: { name: 'dav2_qryMarcacionesFueraArea' },
        dav2_qryVisitasSinDatos: { name: 'dav2_qryVisitasSinDatos' },
        dav2_qryVisitasSinTareas: { name: 'dav2_qryVisitasSinTareas' },
        dav2_qryRecorridoPersonal: { name: 'dav2_qryRecorridoPersonal' },
        dav2_qryContactosPersonal: { name: 'dav2_qryContactosPersonal' },
        dav2_qryResumenVisita: { name: 'dav2_qryResumenVisita' },
    }
)

export class DashboardV2Def extends EntityDefinition {

    columns = columns();
    procs = procs();

    constructor() {
        super('DashboardV2');
    }
}